// extracted by mini-css-extract-plugin
module.exports = {"useOfForceForm":"UseOfForceForm_useOfForceForm__1cGf8"};